import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import iconSet from '../../assets/selection.json';
import IcomoonReact from 'icomoon-react';
import * as colors from '../../common/styles/colors';

import { ButtonPrimary, ModalClose } from '../../common/components';

type AdminBulkUploadFailureModalProps = {
  onClose: () => void;
  failureMessages: Array<string> | undefined;
  missingFiles: Array<Api.IMissingFile> | undefined;
};

export const ContentWrapper = styled.div`
  .failure-icon {
    display: inline-block;
    padding: 25px;
    width: 80px;
    height: 80px;
    text-align: center;
    background: #ccc;
    border-radius: 50%;
    margin-bottom: 10px;
  }

  li {
    list-style-type: none;
    margin-top: 20px;
  }
`;

export const AdminBulkUploadFailureModal = (props: AdminBulkUploadFailureModalProps) => {
  const { onClose, failureMessages = [''], missingFiles = [] } = props;

  return (
    <Modal animation={false} className={'mid-size-modal'} show={true} size={'lg'} backdrop='static' centered>
      <Modal.Header className='pl-lg-4 pt-0'>
        <Modal.Title style={{ color: colors.hydroBlue }}>Bulk Upload Failure</Modal.Title>
        <ModalClose onClick={onClose} />
      </Modal.Header>

      <Modal.Body className='pl-lg-4'>
        <ContentWrapper>
          <div className='d-flex justify-content-center align-items-center'>
            <span className='failure-icon'>
              <IcomoonReact iconSet={iconSet} color={'white'} size={30} icon='cross' />
            </span>
          </div>
          <ul>
            {failureMessages.map((msg: string, i: number) => (
              <li key={i}>{msg}</li>
            ))}
          </ul>
          <ul>
            {missingFiles?.map((m: Api.IMissingFile, i: number) => (
              <li key={i}>
                Row Number: {m.rowNumber} - {m.item}
              </li>
            ))}
          </ul>
          <br />
          <br />
        </ContentWrapper>
      </Modal.Body>
      <Modal.Footer className='p-0'>
        <ButtonPrimary onClick={onClose} className={'mr-0'} title='OK' route='#' />
      </Modal.Footer>
    </Modal>
  );
};
